import React from 'react'
import { useState } from 'react';
import { ModalPortal } from '../../components/ModalPortal';
import { Spinner } from '../../components/Spinner';
import { Album } from '../../components/svg/Album'
import { ToolTip } from '../../components/ToolTip';
import { LoadingContent } from '../../components/LoadingContent';

export const GaleryModal = ({ style, arrFotos }) => {
    const [show, setShow] = useState(false)
    const [isLoading, setIsLoading] = useState();

    const handleShow = () => {
        // loadHistorialScreen()
        setShow(true)
    }

    const handleClose = () => {
        setShow(false)
    }

    return (
        <>
            <ToolTip tip={"Trabajos realizados"} style={style}>
                <button className="btn-icon" onClick={handleShow}>
                    <Album ></Album>
                </button>
            </ToolTip>

            <ModalPortal
                show={show}
                onClose={handleClose}
                title={`Ver historial`}
                size={"lg"}
                footer={
                    <>
                        <div className="galery-modal__btn-container">
                            <button id="modal-volver" className="btn-secondary">Volver</button>
                        </div>
                    </>
                }
            >
                {!isLoading && <>
                    <div className="historial-container">
                        aca va data
                    </div>
                </>}

                {isLoading && <LoadingContent></LoadingContent>}

            </ModalPortal>


        </>
    )
}
